import React from 'react';
import Styled from 'styled';
import SVGIconView from 'lib/images/svg-icon-view';
import { Mutation } from '@apollo/client/react/components';
import { Formik } from 'formik';
import Input from 'four-nets/ui-v2/form/input/input';
import LinkView from 'lib/ui/link-view';
import { Field, FieldProps } from 'formik';
import { Form } from 'formik';
import { Button } from '@rmwc/button';
import '@rmwc/button/styles';

import { ViewerConsumer } from 'four-nets/user/viewer/viewer';
import IconNewsLetter from 'four-nets/icons/svg/icon_newsletter.svg';
import { FormattedMessage } from 'react-intl';
import subscribeToNewsletterMutation, {
    SubscribeToNewsletterMutation,
    SubscribeToNewsletterMutationVariables,
} from './mutation.graphql';
import defaultStyles from './newsletter.scss';

export interface Props {
    styles: typeof defaultStyles;
}

export interface State {
    signed: boolean;
}

interface Values {
    email: string;
}

class Newsletter extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { signed: false };
    }

    render() {
        const { styles } = this.props;
        return (
            <ViewerConsumer>
                {({ viewer }) =>
                    viewer && !(viewer as any).is_subscribed_to_newsletter ? null : (
                        <div id='newsletter-native' className={styles.container}>
                            <div className={styles.top}>
                                <div className={styles.title}>
                                    <span className={styles.name}>NewsLetter</span>
                                    <SVGIconView className={styles.icon} src={IconNewsLetter} />
                                </div>
                                <div className={styles.info}>
                                    <FormattedMessage id='NEWSLETTER_MAGAZIN' />
                                </div>
                            </div>
                            {this.state.signed ? (
                                <div className={styles.succesfull}>
                                    <FormattedMessage id='NEWSLETTER_SUCCESSFUL_SUBSCRIPTION' />
                                </div>
                            ) : (
                                <div className={styles.bottom}>
                                    <Mutation<SubscribeToNewsletterMutation, SubscribeToNewsletterMutationVariables>
                                        mutation={subscribeToNewsletterMutation}
                                    >
                                        {subscribe => (
                                            <Formik
                                                initialValues={{ email: (viewer && (viewer as any).email) || '' }}
                                                onSubmit={value => {
                                                    this.setState({ signed: true });
                                                    subscribe({
                                                        variables: {
                                                            input: {
                                                                email: value.email,
                                                            },
                                                        },
                                                    });
                                                }}
                                                validate={values => {
                                                    const errors: { [k in keyof Values]+?: React.ReactNode } = {};
                                                    if (!values.email) {
                                                        errors.email = (
                                                            <FormattedMessage id='FORM_REQUIRED_VALIDATOR_ERROR' />
                                                        );
                                                    } else if (
                                                        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
                                                    ) {
                                                        errors.email = (
                                                            <FormattedMessage id='FORM_INVALID_EMAIL_VALIDATOR_ERROR' />
                                                        );
                                                    }
                                                    return errors;
                                                }}
                                            >
                                                {formik => {
                                                    const { isSubmitting, touched, errors } = formik;
                                                    return (
                                                        <Form className={styles.form}>
                                                            <Field name='email'>
                                                                {({ field }: FieldProps) => (
                                                                    <React.Fragment>
                                                                        <Input
                                                                            errors={
                                                                                errors.email
                                                                                    ? [errors.email]
                                                                                    : undefined
                                                                            }
                                                                            touched={touched.email != null}
                                                                            {...field}
                                                                            disabled={isSubmitting}
                                                                        />
                                                                        <Button
                                                                            type='submit'
                                                                            className={styles.subscribeButton}
                                                                            unelevated={true}
                                                                        >
                                                                            <FormattedMessage id='SUBSCRIBE' />
                                                                        </Button>
                                                                    </React.Fragment>
                                                                )}
                                                            </Field>
                                                        </Form>
                                                    );
                                                }}
                                            </Formik>
                                        )}
                                    </Mutation>
                                    <span className={styles.eula}>
                                        <LinkView className={styles.eulaLink} to='/about-privacy/'>
                                            <FormattedMessage id='READ_TERMS' />
                                        </LinkView>
                                        <span>
                                            <FormattedMessage id='PROCESS_PERSONAL_DATA' />
                                        </span>
                                    </span>
                                </div>
                            )}
                        </div>
                    )
                }
            </ViewerConsumer>
        );
    }
}

export default Styled(defaultStyles)(Newsletter);
